import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';

import Loader from '../../../components/Common/Loader/Loader';
import TopFeature from '../topFeature/TopFeature';

import getAllHomePageCategorySettings from './getAllHomePageCategorySettings.graphql';
import { withQuery } from '../../../hoc/withGraphql';


export class categorySettings extends Component {
    static defaultProps = { data: { loading: true } };
    render() {
        const { data: { loading, getAllHomePageCategorySettings } } = this.props;
        return (
            <Loader type={"page"} show={loading}>
                <TopFeature />
            </Loader>
        )
    }
}

export default compose(withQuery(getAllHomePageCategorySettings, {
    options: (props) => ({
        fetchPolicy: 'network-only',
        ssr: false
    })
}))(categorySettings)
